/* Anemoia — cart drawer enhancements: per-item "Add to favourites" + a "You may also like"
   recommendations rail. Runtime-injected so Dawn's cart-drawer.liquid stays untouched; re-runs
   whenever Dawn re-renders the drawer (add / quantity change). Depends on the wishlist API
   (window.AnemoiaWishlist) for favourites; degrades gracefully if it isn't present. */
(function(){
  'use strict';
  var RECS_SECTION='anemoia-cart-recs';
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var HEART='<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.6-9.3-9C1.2 8 2.6 5 5.6 5c2 0 3.2 1.3 3.9 2.4l.5.8.5-.8C11.2 6.3 12.4 5 14.4 5c3 0 4.4 3 2.9 6-2.3 4.4-9.3 9-9.3 9z"/></svg>';

  function injectCss(){
    if(document.getElementById('anemoia-cdr-css'))return;
    var s=document.createElement('style'); s.id='anemoia-cdr-css';
    s.textContent=[
      /* Wider drawer — Dawn's default 40rem is cramped once the item list + "you may also like" are in. */
      '.cart-drawer .drawer__inner{width:min(540px, calc(100vw - 3rem)) !important;}',
      '.cart-item__details .awl-fav{margin-top:10px;}',
      '#cdr-wrap{grid-column:1 / -1;}',
      '.cdr{border-top:1px solid rgba(31,23,19,.14);margin-top:6px;padding-top:20px;}',
      '.cdr__title{font-family:var(--font-body-family);font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:#8a7d70;margin:0 0 16px;}',
      '.cdr__row{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;}',
      '.cdr__card{display:flex;flex-direction:column;gap:6px;text-decoration:none;color:#1f1713;}',
      '.cdr__img{display:block;aspect-ratio:3/4;background:#efeae3;overflow:hidden;}',
      '.cdr__img img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .5s ease;}',
      '.cdr__card:hover .cdr__img img{transform:scale(1.04);}',
      '.cdr__name{font-family:var(--font-heading-family,serif);font-size:13px;line-height:1.25;}',
      '.cdr__price{font-family:var(--font-body-family);font-size:12px;color:#8a7d70;}',
      '.cdr__title--2{margin-top:22px;}',
      '.cdr__row[data-cdr-rotate] .cdr__card{animation:cdrIn .6s ease;}',
      '.cdr__row[data-cdr-rotate] .cdr__card[hidden]{display:none;}',
      '@keyframes cdrIn{from{opacity:0}to{opacity:1}}',
      '@media (prefers-reduced-motion:reduce){.cdr__row[data-cdr-rotate] .cdr__card{animation:none;}}',
      '@media (max-width:600px){.cdr__row{grid-template-columns:repeat(2,1fr);} .cdr__row{gap:10px;} }'
    ].join('\n');
    document.head.appendChild(s);
  }

  function itemData(li){
    var link=li.querySelector('.cart-item__name'); if(!link) return null;
    var href=link.getAttribute('href')||'';
    var handle=(href.split('/products/')[1]||'').split('?')[0].split('#')[0].replace(/\/$/,'');
    if(!handle) return null;
    var img=li.querySelector('.cart-item__image');
    var price=li.querySelector('.cart-item__totals .price, .cart-item__price-wrapper .price');
    return { handle:handle, url:'/products/'+handle, title:(link.textContent||'').replace(/\s+/g,' ').trim(),
      image:img?(img.currentSrc||img.src):'', price:price?(price.textContent||'').replace(/\s+/g,' ').trim():'' };
  }

  function injectFav(){
    var WL=window.AnemoiaWishlist;
    var items=document.querySelectorAll('#CartDrawer .cart-item:not([data-awl-fav-done])');
    Array.prototype.forEach.call(items,function(li){
      li.setAttribute('data-awl-fav-done','1');
      var d=itemData(li); if(!d) return;
      var details=li.querySelector('.cart-item__details'); if(!details) return;
      var saved=WL&&WL.has&&WL.has(d.handle);
      var b=document.createElement('button'); b.type='button'; b.className='awl-fav'+(saved?' is-on':'');
      b.setAttribute('data-awl-h',d.handle); b.setAttribute('data-awl-url',d.url);
      b.setAttribute('data-awl-title',d.title); b.setAttribute('data-awl-img',d.image); b.setAttribute('data-awl-price',d.price);
      b.innerHTML=HEART+'<span>'+(saved?'Saved':'Add to favourites')+'</span>';
      details.appendChild(b);
    });
  }

  var recsHTML=null, recsPid=null, recsFetching=false;
  function placeRecs(){
    var host=document.querySelector('#CartDrawer-CartItems'); if(!host||!recsHTML) return;
    if(document.getElementById('cdr-wrap')) return;
    var wrap=document.createElement('div'); wrap.id='cdr-wrap'; wrap.innerHTML=recsHTML;
    host.appendChild(wrap);
    startRotation(wrap);
  }

  /* Slow, even rotation: shows 4 cards (2 on phones), swaps every 14 s, pauses while the shopper
     hovers, touches or focuses the row, and never moves with reduced motion. */
  var rotTimer=null;
  function startRotation(wrap){
    clearInterval(rotTimer);
    var rows=wrap.querySelectorAll('[data-cdr-rotate]');
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    var states=[];
    Array.prototype.forEach.call(rows,function(row){
      var cards=row.querySelectorAll('.cdr__card'); if(!cards.length) return;
      var st={row:row,cards:cards,page:0,hold:false};
      ['mouseenter','touchstart','focusin'].forEach(function(e){row.addEventListener(e,function(){st.hold=true;},{passive:true});});
      ['mouseleave','focusout'].forEach(function(e){row.addEventListener(e,function(){st.hold=false;});});
      states.push(st); show(st);
    });
    function per(){ return (window.matchMedia&&matchMedia('(max-width:600px)').matches)?2:4; }
    function show(st){ var n=per(), pages=Math.max(1,Math.ceil(st.cards.length/n)); st.page=st.page%pages;
      Array.prototype.forEach.call(st.cards,function(c,i){ c.hidden=!(i>=st.page*n && i<(st.page+1)*n); }); }
    if(reduce) return;
    rotTimer=setInterval(function(){
      var cd=document.querySelector('cart-drawer'); if(cd&&!cd.classList.contains('active')) return;
      states.forEach(function(st,ix){ if(st.hold||st.cards.length<=per()) return;
        /* offset the two rows by half a beat so they never change together */
        setTimeout(function(){ st.page++; show(st); }, ix*7000);
      });
    },14000);
  }
  /* "You may also like" follows what the shopper shows interest in: pieces in the cart (weight 3),
     saved pieces (weight 2) and recently viewed pieces (weight 1, newest first). Recommendations are
     fetched for up to 4 of those seeds and merged; a piece suggested by several seeds ranks first.
     "Complete the look" comes from the section itself and depends only on the cart. */
  var VIEW_KEY='av_viewed';
  function viewed(){ try{ return JSON.parse(localStorage.getItem(VIEW_KEY))||[]; }catch(e){ return []; } }
  function recordView(){
    var m=location.pathname.match(/\/products\/([^\/?#]+)/); if(!m) return;
    var h=decodeURIComponent(m[1]); var a=viewed().filter(function(x){return x!==h;}); a.unshift(h);
    try{ localStorage.setItem(VIEW_KEY,JSON.stringify(a.slice(0,12))); }catch(e){}
  }
  function saved(){ try{ return (JSON.parse(localStorage.getItem('anemoiaWishlist'))||[]).map(function(x){return x.handle;}); }catch(e){ return []; } }
  var idCache={};
  function idFor(handle){
    if(idCache[handle]) return Promise.resolve(idCache[handle]);
    return fetch(root+'products/'+handle+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){ if(p&&p.id){ idCache[handle]=p.id; return p.id; } return null; }).catch(function(){return null;});
  }
  function refreshRecs(){
    if(recsFetching) return;
    var host=document.querySelector('#CartDrawer-CartItems'); if(!host) return;
    recsFetching=true;
    fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      if(!cart.items||!cart.items.length){ recsHTML=null; recsPid=null; recsFetching=false; var ex=document.getElementById('cdr-wrap'); if(ex)ex.remove(); return; }
      var inCart={}; cart.items.forEach(function(i){ inCart[i.product_id]=1; });
      var cartHandles=cart.items.map(function(i){return i.handle;});
      var seeds=[]; function add(h,w){ if(!h) return; for(var k=0;k<seeds.length;k++){ if(seeds[k].h===h){ seeds[k].w+=w; return; } } seeds.push({h:h,w:w}); }
      cartHandles.forEach(function(h){add(h,3);}); saved().forEach(function(h){add(h,2);}); viewed().slice(0,6).forEach(function(h){add(h,1);});
      seeds.sort(function(a,b){return b.w-a.w;}); seeds=seeds.slice(0,4);
      var key=cart.items.map(function(i){return i.product_id;}).join(',')+'|'+seeds.map(function(x){return x.h;}).join(',');
      if(key===recsPid && recsHTML){ recsFetching=false; placeRecs(); return; }
      Promise.all(seeds.map(function(sd){ return idFor(sd.h).then(function(id){
        if(!id) return null;
        return fetch(root+'recommendations/products?product_id='+id+'&limit=12&intent=related&section_id='+RECS_SECTION).then(function(r){return r.text();}).then(function(html){ return {w:sd.w,html:html}; });
      }); })).then(function(results){
        var score={}, card={}, order=0, row2=null;
        results.forEach(function(res,ri){ if(!res) return;
          var tmp=document.createElement('div'); tmp.innerHTML=res.html;
          var rows=tmp.querySelectorAll('.cdr__row');
          var titles=tmp.querySelectorAll('.cdr__title');
          Array.prototype.forEach.call(rows,function(row,i){
            var isLook=titles[i]&&/complete the look/i.test(titles[i].textContent);
            if(isLook){ if(!row2) row2=row.innerHTML; return; }
            Array.prototype.forEach.call(row.querySelectorAll('.cdr__card'),function(c,pos){
              var pid=c.getAttribute('data-pid'); if(!pid||inCart[pid]) return;
              if(!card[pid]){ card[pid]=c.outerHTML; score[pid]={s:0,o:order++}; }
              score[pid].s+=res.w*(1-pos/24);
            });
          });
        });
        var ids=Object.keys(score).sort(function(a,b){ return (score[b].s-score[a].s)||(score[a].o-score[b].o); }).slice(0,12);
        var out='';
        if(ids.length){ out+='<p class="cdr__title">You may also like</p><div class="cdr__row" data-cdr-rotate>'+ids.map(function(i){return card[i];}).join('')+'</div>'; }
        if(row2){ out+='<p class="cdr__title cdr__title--2">Complete the look</p><div class="cdr__row" data-cdr-rotate>'+row2+'</div>'; }
        recsPid=key; recsHTML=out?'<div class="cdr">'+out+'</div>':null; recsFetching=false;
        var ex=document.getElementById('cdr-wrap'); if(ex)ex.remove();
        placeRecs();
      }).catch(function(){ recsFetching=false; });
    }).catch(function(){ recsFetching=false; });
  }

  function enhance(){
    if(!document.getElementById('CartDrawer')) return;
    // Clear a lingering empty-state class (Dawn keeps `is-empty` on <cart-drawer> when you add from an
    // empty cart, which hides the items). Covers both the quick-view and product-page add paths.
    var cd=document.querySelector('cart-drawer');
    if(cd && cd.classList.contains('is-empty') && cd.querySelector('.cart-item')) cd.classList.remove('is-empty');
    injectCss();
    injectFav();
    placeRecs();
    // Self-heal: if the drawer has items but the rail isn't fetched/placed yet (e.g. the FIRST add,
    // where the open-observer fired before Dawn finished rendering the item), fetch it now. Guarded
    // by recsFetching + the pid cache so this can't loop or double-fetch.
    if(cd && cd.querySelector('.cart-item') && !document.getElementById('cdr-wrap')) refreshRecs();
    if(window.AnemoiaWishlist&&window.AnemoiaWishlist.sync) window.AnemoiaWishlist.sync();
  }

  var t=null;
  function debouncedEnhance(){ clearTimeout(t); t=setTimeout(enhance,60); }

  function boot(){
    recordView();
    var cd=document.querySelector('cart-drawer'); if(!cd) return;
    enhance();
    // Re-inject after Dawn re-renders the drawer contents (add / quantity change).
    new MutationObserver(debouncedEnhance).observe(cd,{subtree:true,childList:true});
    // Load recommendations when the drawer opens; refresh if the top item changed.
    var wasOpen=false;
    new MutationObserver(function(){
      var open=cd.classList.contains('active');
      if(open&&!wasOpen){ refreshRecs(); }
      wasOpen=open;
    }).observe(cd,{attributes:true,attributeFilter:['class']});
    if(cd.querySelector('.cart-item')) refreshRecs();
  }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();
